import { Box, useTheme } from "@mui/material";
import React from "react";

export const AnimatedThreeDots = () => {
  const theme = useTheme();
  const dotsColour = theme.palette.mode === "dark" ? "white" : "black";

  return (
    <Box
      className="loader-container"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        "& .bouncing-dots": {
          display: "flex",
          justifyContent: "space-between",
          width: "52px",
        },
        "& .dot": {
          width: "12px",
          height: "12px",
          backgroundColor: dotsColour,
          borderRadius: "50%",
          animation: "bounce 1.5s infinite",
        },
        "& .dot:nth-child(1)": {
          animationDelay: "0s",
        },
        "& .dot:nth-child(2)": {
          animationDelay: "0.3s",
        },
        "& .dot:nth-child(3)": {
          animationDelay: "0.6s",
        },
        "@keyframes bounce": {
          "0%, 100%": {
            transform: "translateY(0)",
          },
          "50%": {
            transform: "translateY(-10px)",
          },
        },
      }}
    >
      <div className="bouncing-dots">
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
      </div>
    </Box>
  );
};
